export default "__VITE_ASSET__BrpeMgGZ__"